import React, { useState, useEffect } from "react";
import "./Login.scss";
import { Link, useNavigate } from "react-router-dom";
import { signUpWithEmail, signInWithGoogle, signInWithFacebook } from "../../Supabase/Config";
import { IoMdCloseCircle } from "react-icons/io";

function SignUp() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  // Surface OAuth errors captured during the provider redirect.
  useEffect(() => {
    const oauthError = sessionStorage.getItem("oauth_error");
    if (oauthError) {
      setError(oauthError);
      sessionStorage.removeItem("oauth_error");
    }
  }, []);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSignUp = async () => {
    if (!validateEmail(email)) {
      setError("Invalid email address.");
      return;
    }

    if (password.length < 6) {
      setError("Password must be at least 6 characters.");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    setIsLoading(true);
    setError("");

    try {
      const { user, session } = await signUpWithEmail(email, password);
      
      if (session) {
        sessionStorage.setItem("tokens", "100");
        sessionStorage.setItem("name", user.email?.split('@')[0] || 'User');
        localStorage.setItem("jwt", session.access_token);
        setSuccessMessage("Signup successful! Redirecting...");
        setTimeout(() => {
          navigate("/chatbot");
        }, 1000);
      } else {
        setSuccessMessage("Signup successful! You can now log in.");
        setTimeout(() => {
          navigate("/login");
        }, 2000);
      }
      setIsLoading(false);
    } catch (error) {
      setError(error.message || "An error occurred during signup.");
      setIsLoading(false);
    }
  };

  const handleGoogleSignUp = async () => {
    setIsLoading(true);
    setError("");
    try {
      sessionStorage.setItem("oauth_origin", "signup");
      await signInWithGoogle();
      // On success the browser is redirected to the provider; no further code runs.
    } catch (error) {
      setError(error.message || "Failed to sign up with Google.");
      setIsLoading(false);
    }
  };

  const handleFacebookSignUp = async () => {
    setIsLoading(true);
    setError("");
    try {
      sessionStorage.setItem("oauth_origin", "signup");
      await signInWithFacebook();
      // On success the browser is redirected to the provider; no further code runs.
    } catch (error) {
      setError(error.message || "Failed to sign up with Facebook.");
      setIsLoading(false);
    }
  };

  return (
    <React.Fragment>
      <div className="login">
        <div className="block">
          <img className="back" src="/images/login.svg" alt="login" />
        </div>
        <div className="loginForm">
          <div className="title">
            <Link to="/">
              <img className="exit-logo" src="/images/cross.png" alt="" />
            </Link>
            <h3>
              <img src="/images/logo.svg" alt="logo" />
            </h3>
          </div>
          <div className="buttons">
            <button onClick={handleGoogleSignUp}>
              <img src="/images/wg.svg" alt="google" />
              Continue With Google
            </button>
            <button onClick={handleFacebookSignUp}>
              <img src="/images/facebook.svg" alt="linkedin" />
              Continue With Facebook
            </button>
          </div>
          <div className="or">
            <p>
              <span>Or sign up with email</span>
            </p>
          </div>
          <div className="form-group">
            <input
              type="email"
              placeholder="Enter your Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <img src="/images/f1.svg" alt="img" />
          </div>
          <div className="form-group">
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <img src="/images/f2.svg" alt="img" />
          </div>
          <div className="form-group">
            <input
              type="password"
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            <img src="/images/f2.svg" alt="img" />
          </div>

          {error && (
            <p className="error-message">
              <span style={{ marginRight: "15px", fontSize: "25px" }}>
                <IoMdCloseCircle />
              </span>
              {error}
            </p>
          )}

          {successMessage && <p className="success">{successMessage}</p>}

          <button
            className="loginBtn"
            onClick={handleSignUp}
            disabled={isLoading}
          >
            {isLoading ? "Signing Up..." : "Sign up with Regal Bot"}
          </button>
          <div className="register">
            <p>
              Already have an account? <Link to="/login">Login</Link>
            </p>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default SignUp;
